import { useState } from 'react'
import { factionOf } from '@/lib/factions'

/**
 * A faction's mark. Renders `/factions/<slug>.webp`, and on a missing file
 * falls back to the faction's colour as a dot — the picker stays usable before
 * the artwork is uploaded, and a typo in a filename never leaves a broken image.
 */
export default function FactionIcon({ faction, className = 'h-4 w-4' }: {
  faction?: string | null
  className?: string
}) {
  const [failed, setFailed] = useState(false)
  const f = factionOf(faction)
  if (!f) return null
  if (failed) {
    return (
      <span
        className={`${className} rounded-full shrink-0`}
        style={{ backgroundColor: f.color }}
        title={f.label}
      />
    )
  }
  return (
    <img
      src={f.icon}
      alt={f.label}
      title={f.label}
      onError={() => setFailed(true)}
      className={`${className} object-contain shrink-0`}
    />
  )
}
